import Profile from "_c/modules/profile/common/profile";
import { connect } from "react-redux";
import { Selectors } from "@/store/saloonProfile/selectors";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { Effects } from "@/store/saloonProfile/effects";
import { Effects as MessengerEffects } from "@/store/messenger/effects";
import { Effects as FavEffects } from "@/store/favorites/effects";
import { Actions as ModalActions } from "@/store/modals/slice";

const mSp = (state) => ({
  name: Selectors.getTitle(state),
  avatar: Selectors.getLogo(state),
  isAuth: AuthSelectors.isAuth(state),
  isOwner: Selectors.isOwner(state),
  isPremium: Selectors.isPremium(state),
  bio: Selectors.getDesc(state),
  rate: Selectors.getRate(state),
  reviewsCount: Selectors.getReviewsCount(state),
  address: Selectors.getHrAddress(state),
  idForMessenger: Selectors.getOwner(state),
  favType: "saloons",
  isFavorite: Selectors.isFavorite(state),
  favId: Selectors.getFavoriteId(state),
  shareId: Selectors.getId(state),
  avatarAltText: Selectors.getAvatarAltText(state),
});
const mDp = {
  updateAvatar: Effects.updateLogo,
  sendMessage: MessengerEffects.createMessageOutsideMessenger,
  toggleFavorite: FavEffects.toggleFavorite,
  openAuthModal: ModalActions.openAuth,
  openShareModal: ModalActions.openShare,
};

export default connect(mSp, mDp)(Profile);
